var toId = require('../utils/to-id')
var findMany = require('./find-many')
var addMany = require('./add-many')

module.exports = function findOrAddMany (state, passedObjects, prefix) {
  var foundObjects
  var passedObjectIds = passedObjects.map(toId)

  if (prefix) {
    passedObjectIds = passedObjectIds.map(function (id) {
      return prefix + id
    })
  }

  return findMany(state, passedObjectIds, prefix)

  .then(function (_foundObjects) {
    foundObjects = _foundObjects

    var foundObjectIds = foundObjects.map(toId)
    var notFoundObjects = passedObjects.reduce(function (notFoundObjects, passedObject) {
      if (foundObjectIds.indexOf((prefix || '') + passedObject._id) === -1) {
        notFoundObjects.push(passedObject)
      }
      return notFoundObjects
    }, [])

    return addMany(state, notFoundObjects, prefix)
  })

  .then(function (addedObjects) {
    var objects = []

    foundObjects.concat(addedObjects).forEach(function (object) {
      var index = passedObjectIds.indexOf(object._id)
      objects[index] = object
    })

    return objects
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-hoodie-api/lib/helpers/find-or-add-many.js
// module id = 745
// module chunks = 7